import { memo } from 'react';

import { PROFILE } from 'helpers/routes';
import PageNavigation, { NavigationItem } from 'components/common/PageNavigation';
// import styles from "./ProfileNavigation.module.scss";

const ProfileNavigation = memo(() => {
  const navigationItems: NavigationItem[] = [
    { to: PROFILE.profile, text: 'profile.profile_menu.profile', exact: true },
    { to: PROFILE.employees, text: 'profile.profile_menu.employee' },
    { to: PROFILE.documents, text: 'profile.profile_menu.document' },
    { to: PROFILE.park, text: 'profile.profile_menu.park' },
  ];

  return <PageNavigation navigationItems={navigationItems} className="page__navigation--profile" />;
});

ProfileNavigation.displayName = 'ProfileNavigation';

export default ProfileNavigation;
